import { Text } from '@equip.health/ui';
import { FC } from 'react';
import { TextProps } from '@equip.health/ui/lib/types/src/components/Text/Text';

const ValueOrNotSet: FC<TextProps & { value: string | undefined }> = ({
  value,
  ...rest
}) => {
  return (
    <Text color={value ? undefined : 'neutral.tertiary'} {...rest}>
      {value ? value : 'Not set'}
    </Text>
  );
};

export default ValueOrNotSet;
